import api from '../../utils/axios';

export const agentService = {
  getProfile: async () => {
    const response = await api.get('/agent/profile');
    return response.data;
  },

  updateProfile: async (userId, payload) => {
    const response = await api.put(`/auth/${userId}`, payload);
    return response.data;
  },

  sendOtp: async (method, payload) => {
    const endpoint = method === 'email' ? '/auth/sendOtp' : '/auth/sendSmsOtp';
    const response = await api.post(endpoint, payload);
    return response.data;
  },

  verifyOtp: async (method, payload) => {
    const endpoint = method === 'email' ? '/auth/verifyOtp' : '/auth/verifySmsOtp';
    const response = await api.post(endpoint, payload);
    return response.data;
  },

  resetPassword: async (payload) => {
    const response = await api.post('/auth/reset-password', payload);
    return response.data;
  },

  uploadLogo: async (formData) => {
    const response = await api.post('/upload/single', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  markAppShared: async () => {
    try {
      const response = await api.post('/agent/mark-shared');
      return response.data;
    } catch (err) {
      console.error('Failed to mark app as shared on backend:', err);
    }
  },

  requestCallback: async () => {
    const response = await api.post('/agent/request-callback');
    return response.data;
  }
};
